import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LsbUtils, RoutePaths } from '@shared/utils';
import type { LifestyleCategoryType } from '@shared/api';
import { Request, SpecialOffers } from './widgets';
import { PageContainer } from '@widgets';

export const ConciergeRequestPage = () => {
  const { type } = useParams<{ type: LifestyleCategoryType }>();

  const { t } = useTranslation('concierge');

  const lifestyleCategory = LsbUtils.getLifestyleCategoryByType(type!);

  if (!lifestyleCategory) return <Navigate to={RoutePaths.concierge.onNavigate()} replace />;
  return (
    <PageContainer
      className='flex flex-col gap-6'
      title={lifestyleCategory.title}
      back
      backText={t('backText')}
      to={RoutePaths.concierge.onNavigate()}
    >
      <Request category={lifestyleCategory} />
      {lifestyleCategory.type !== 'other' && <SpecialOffers type={lifestyleCategory.type} />}
    </PageContainer>
  );
};
